<template>
  <lu-vbox lu-flex class='tab-container' style='height: 100%'>
    <Spinner ref='spinner' style='z-index:60000 !important'/>

    <el-form label-position="right"  style='flex: 1 1 auto; display: flex;' ref="form" :model='form' lu-flex label-width="110px">
    <el-tabs class='siteTabs' v-if="form && form.bookList && form.bookList.length" v-model="activeName" tab-position="top"  type="border-card" style="margin: 20px;">
        <el-tab-pane :lazy="true" v-for='(book, bookIdx) in form.bookList' :key='bookIdx' :label="book.bookName" :name="book.bookName" style='padding: 10px'>
          <lu-vbox lu-flex>
            <lu-hbox lu-hright class='pad-in-5' >
              <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('save') }}</el-button></lu-item>
            </lu-hbox>
            <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
              <lu-vbox v-if="book && book.parameterList && book.parameterList.length">
                  <lu-vbox v-for="(param, paramIdx) in book.parameterList" :key='paramIdx' style='margin-top:20px;'>
                    <lu-vbox v-if="param">
                      <lu-hbox lu-click lu-vcenter class='title pad-in-5' @click='toggleParam(book, param)'>
                        <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' :class="{'isActive': param.isActive}"/>
                        <lu-item >{{ param.paramName }}</lu-item>
                      </lu-hbox>
                      <lu-vbox v-if="param.isActive && param && param.brokerList && param.brokerList.length" style="margin-left: 28px">
                        <lu-vbox v-for="(broker, brokerIdx) in param.brokerList" :key='brokerIdx' style='margin-top:10px;'>
                          <lu-vbox v-if="broker">
                            <lu-hbox lu-click lu-vcenter class='subtitle pad-in-5' @click='toggleBroker(book, param, broker)'>
                              <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' :class="{'isActive': broker.isActive}" />
                              <lu-item>{{ broker.brokerName }}</lu-item>
                            </lu-hbox>
                            <lu-vbox v-if="broker.isActive">
                              <lu-item v-if="broker.hasOwnProperty('groupList')">
                                <el-form-item style='width:800px;margin: 0;' :label="$t('Group List')" prop="groupList" label-width="150px">
                                    <el-input autosize type="textarea" v-model='broker.groupList'/>
                                </el-form-item>
                              </lu-item>
                              <lu-item v-if="broker.hasOwnProperty('accountsList')">
                                <el-form-item style='width:800px;margin: ;' :label="$t('Account List')" prop="accountsList" label-width="150px">
                                  <el-input autosize type="textarea" v-model='broker.accountsList'/>
                                </el-form-item>
                              </lu-item>
                            </lu-vbox>
                          </lu-vbox>
                        </lu-vbox>
                      </lu-vbox>
                    </lu-vbox>
                  </lu-vbox>
              </lu-vbox>
            </lu-scroll-area>
          </lu-vbox>
        </el-tab-pane>
    </el-tabs>
    </el-form>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuItem, LuVbox, LuScrollArea } from 'lusis-ui'
import Spinner from '@/components/Spinner'
import FontIcon from '@/components/FontIcon'

export default {
  name: 'ReconciliationConfig',
  components: { Spinner, FontIcon, LuHbox, LuItem, LuVbox, LuScrollArea },
  data () {
    return {
      activeName: "",
      forceLoading: false,
      bookList:[],
      form: {
        bookList: []
      }
    }
  },
  methods: {
    makeDiff (serverBookList, clientBookList, compBook, compParam, compBroker, diffBroker) {
      let bookList = []
      if (clientBookList && serverBookList) {
        clientBookList.forEach(bookClient => {
          let parameterList = []
          let idxBook = serverBookList.findIndex(bookServer => compBook(bookServer, bookClient))
          if (idxBook !== -1 && serverBookList[idxBook]) {
            let clientParameterList = bookClient.parameterList
            let serverParameterList = serverBookList[idxBook].parameterList

            if (clientParameterList && serverParameterList) {
              clientParameterList.forEach(paramClient => {
                let brokerList = []
                let idxParam = serverParameterList.findIndex(paramServer => compParam(paramServer, paramClient))
                if (idxParam !== -1 && serverParameterList[idxParam]) {
                  let clientBrokerList = paramClient.brokerList
                  let serverBrokerList = serverParameterList[idxParam].brokerList

                  if (clientBrokerList && serverBrokerList) {
                    clientBrokerList.forEach(brokerClient => {
                      let idxBroker = serverBrokerList.findIndex(brokerServer => compBroker(brokerServer, brokerClient))
                      if (idxBroker !== -1 && serverBrokerList[idxBroker]) {
                        let brokerServer = serverBrokerList[idxBroker]
                        if (brokerServer && diffBroker(brokerServer, brokerClient)) {
                          brokerList.push(Object.assign({}, brokerClient))
                        }
                      }
                    })
                    if (brokerList && brokerList.length) {
                      parameterList.push({ paramName: paramClient.paramName, brokerList: brokerList })
                    }
                  }
                }
              })
              if (parameterList && parameterList.length) {
                bookList.push({ bookName: bookClient.bookName, parameterList: parameterList })
              }
            }
          }
        })
      }
      return bookList
    },
    cancel () {
      this.form.bookList = this.clone(this.bookList)
    },
    save () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let bookList = this.makeDiff(this.bookList, this.form.bookList, (book1, book2) => book1.bookName === book2.bookName,(param1, param2) => param1.paramName === param2.paramName, (broker1, broker2) => broker1.brokerName === broker2.brokerName, (broker1, broker2) => broker1.groupList !== broker2.groupList || broker1.accountsList !== broker2.accountsList)

            if (bookList && bookList.length) {
              this.$refs.spinner.show()

              let cond = {
                functionId: 'setReconciliation',
                bookList: bookList
              }

              this.$tango.getFunctionData(cond).then(rep => {
                this.$refs.spinner.hide()
                if (rep.resultCode === 0) {
                  this.$message({
                    message: 'Set reconciliation config success',
                    type: 'success'
                  })
                  this.forceLoading = !this.forceLoading
                }
                else {
                  this.cancel()
                  this.$message({
                    message: 'Error set reconciliation config',
                    type: 'error'
                  })
                }
              }).catch(() => {
                this.$refs.spinner.hide()
              })
            }
          }
        })
      })
    },
    clone: function (data) {
      if (Array.isArray(data)) {
        let ret = []
        for (let i = 0; i < data.length; i++) {
          this.$set(ret, i, this.clone(data[i]))
        }
        return ret
      }
      else if (typeof data === 'object') {
        let ret = {}
        for (let k in data) {
          this.$set(ret, k, this.clone(data[k]))
        }
        return ret
      }
      else return data
    },
    toggleParam (book, param) {
      if (book && param) {
        let idxBook = this.bookList.findIndex(b => b.bookName === book.bookName)
        if (idxBook!==-1 && this.form.bookList[idxBook] && this.form.bookList[idxBook].parameterList) {
          let idxParam = this.form.bookList[idxBook].parameterList.findIndex(p => p.paramName === param.paramName)
          if (idxParam!==-1 && this.form.bookList[idxBook].parameterList[idxParam]) {
            this.form.bookList[idxBook].parameterList[idxParam].isActive = !this.form.bookList[idxBook].parameterList[idxParam].isActive
          }
        }
      }
    },
    toggleBroker (book, param, broker) {
      if (book && param && broker) {
        let idxBook = this.bookList.findIndex(b => b.bookName === book.bookName)
        if (idxBook!==-1 && this.form.bookList[idxBook] && this.form.bookList[idxBook].parameterList) {
          let idxParam = this.form.bookList[idxBook].parameterList.findIndex(p => p.paramName === param.paramName)
          if (idxParam!==-1 && this.form.bookList[idxBook].parameterList[idxParam] && this.form.bookList[idxBook].parameterList[idxParam].brokerList) {
            let idxBroker = this.form.bookList[idxBook].parameterList[idxParam].brokerList.findIndex(br => br.brokerName === broker.brokerName)
            if (idxBroker!==-1 && this.form.bookList[idxBook].parameterList[idxParam].brokerList[idxBroker]) {
              this.form.bookList[idxBook].parameterList[idxParam].brokerList[idxBroker].isActive = !this.form.bookList[idxBook].parameterList[idxParam].brokerList[idxBroker].isActive
            }
          }
        }
      }
    }
  },
  asyncComputed: {
    reconciliationConfig: {
      get () {
        this.forceLoading = !this.forceLoading
        let cond = {
          functionId: 'getReconciliation'
        }
        return this.$tango.getFunctionData(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Reconciliation Config')
          } else {
            if (rep.bookList && rep.bookList.length) {
              this.bookList = rep.bookList
            } else {
              this.bookList = []
            }

            //set isActive field
            for (let b = 0; b < this.bookList.length; b++) {
              if (this.bookList[b] && this.bookList[b].parameterList) {
                for (let p = 0; p < this.bookList[b].parameterList.length; p++) {
                  if (this.bookList[b].parameterList[p]) {
                    this.bookList[b].parameterList[p].isActive = true

                    if (this.bookList[b].parameterList[p].brokerList) {
                      for (let br = 0; br < this.bookList[b].parameterList[p].brokerList.length; br++) {
                        if (this.bookList[b].parameterList[p].brokerList[br]) {
                          this.bookList[b].parameterList[p].brokerList[br].isActive = true
                        }
                      }
                    }
                  }
                }
              }
            }

            this.form.bookList = this.clone(this.bookList)
            if (this.bookList && this.bookList.length) {
              this.activeName = this.bookList[0].bookName
            } else {
              this.activeName = ""
            }
            
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: {}
    }
  }
}
</script>

<style lang='scss'>
.siteTabs.el-tabs--top {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.siteTabs .el-tab-pane {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
}
.siteTabs.el-tabs--top .el-tabs__content {
  padding: 10px;
  flex-direction: column;
  flex: 1 1 auto;
}

.siteTabs .title {
  font-size: 1.3em;
  padding: 10px 0;
  font-weight: bold;
}

.siteTabs .subtitle {
  font-size: 1.3em;
  padding: 10px 0;
}

.tab-container {
  .el-form-item {
    width: 300px;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>

